import { MOTION_DURATION } from "@/lib/motion-theme";

/**
 * Shared sound-player motion + control primitives.
 *
 * `itemVariants` and `iconButtonClass` were previously byte-identical copies in
 * both `app/sounds/[id]/sound-player-client.tsx` and
 * `components/sound-player/related-sounds-rail.tsx`. Hoisted here so the stagger
 * variant object stays referentially stable across renders and the two surfaces
 * cannot drift apart.
 */

// Module-scope so the variant object is stable across renders — prevents Framer
// Motion from re-evaluating stagger on every state change.
export const itemVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: MOTION_DURATION.emphasis } },
};

export const iconButtonClass =
  "flex min-h-[44px] min-w-[44px] items-center justify-center rounded-[var(--radius-pill)] border border-[color:var(--tls-border-subtle)] bg-[var(--tls-surface)] text-[var(--tls-fg-muted)] transition-[border-color,background-color,color] duration-[var(--motion-duration-standard)] ease-[var(--motion-ease-standard)] hover:border-[color:var(--tls-border-strong)] hover:bg-[var(--tls-surface-hover)] hover:text-[var(--tls-fg-strong)] tlsr-focus";
